import React from 'react';
import {
  TextField,
  Show,
  SimpleShowLayout
} from 'admin-on-rest/lib/mui';


export const Init = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField label="title" />
        </SimpleShowLayout>
    </Show>
);



// WEBPACK FOOTER //
// ./src/pages/companies/init_page.js